import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteExpCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteExpCategory = createAsyncThunk('deleteExpCategory', async (payload) => {
  return await deleteExpCategoryApi(payload);
});

const deleteExpCategorySlice = createSlice({
  name: 'deleteExpCategory', // Unique Name
  initialState,
  reducers: {
    deleteExpCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteExpCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteExpCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteExpCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteExpCategoryReset } = deleteExpCategorySlice.actions;

export default deleteExpCategorySlice.reducer;
